var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keywords.length > 0)?_c('ul',{staticClass:"search__list"},_vm._l((_vm.keywords),function(item,index){return _c('li',{key:index,staticClass:"search__item pnt",on:{"click":function($event){return _vm.bindWord(item.keyword)}}},[_c('i',{staticClass:"i_search_bl"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.colorWord(item.keyword))}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }